import cleanStateKey from './clean-state-key';

var getState = function getState(state, elementKey, value) {
  var key = cleanStateKey(elementKey);

  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
};

export default getState;


//////////////////
// WEBPACK FOOTER
// ./~/radium/es/get-state.js
// module id = 176
// module chunks = 0